import type { VFC } from 'react'
import { useTableInstance } from '@panwds/react-table'
import { useEffect } from 'react'
import { ARRAY } from '../../../../../common/utils/Utils'
import { Checkbox } from '@panwds/react-ui'
import styled from 'styled-components'
import RowExpansionToggle from '../../../common/permissionsTable/RowExpansionToggle'

const CheckboxWrapper = styled.div`
  label {
    margin: 0;
  }
`

const MappingCell: VFC<any> = ({ row, value, enableRowSelect, onSelect }) => {

  const leafNode = !row?.subRows.length
  const padding = 20 * row.depth + (leafNode ? 24 : 0)

  const tableRef = useTableInstance()

  useEffect(() => {
    if (ARRAY.hasArray(row?.subRows)) {
      for (const subRow of row?.subRows) {
        if (subRow.isSelected && !row.isSelected) {
          continue
        }
        if (subRow.isSelected !== undefined && subRow.isSelected !== row.isSelected) {
          tableRef?.toggleRowSelected(subRow?.id, row.isSelected)
        }
      }
    }
  }, [row, tableRef])

  return (
    <div className='tw-flex tw-items-center tw-gap-2'>
      {enableRowSelect && (
        <CheckboxWrapper>
          <Checkbox checked={row?.isSelected} onChange={() => onSelect(row)}/>
        </CheckboxWrapper>
      )}
      <div style={{ paddingLeft: `${padding}px` }}>
        <div className='tw-flex tw-gap-2'>
          {!leafNode && (<RowExpansionToggle row={row}/>)}
          {value}
        </div>
      </div>
    </div>
  )
}

export default MappingCell
